import React from "react";

const Java_NestedIf = () => {
  return (
    <div>
      <h1>Java NestedIf</h1>
      <p>This page provides explanations, examples, and common use-cases for Java NestedIf in Java.</p>
    </div>
  );
};

export default Java_NestedIf;
